import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function AgencyListMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.contractor.list("agency"));
  };

  return (
    <MainMenuItem
      itemTitleString="代理店情報を見る"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default AgencyListMenuItem;
